import "./MapZoomIndicator.css";

export interface MapZoomIndicatorProps {
    zoom: number;
    aggregationThreshold?: number;
    showAggregationInfo?: boolean;
}

export const MapZoomIndicator = ({
    zoom,
    aggregationThreshold = 14,
    showAggregationInfo = true
}: MapZoomIndicatorProps): JSX.Element => {
    const isUsingAggregations = zoom < aggregationThreshold;

    return (
        <div className="map-zoom-indicator">
            <div className="map-zoom-indicator__zoom">
                <span className="map-zoom-indicator__label">Zoom:</span>
                <span className="map-zoom-indicator__value">{zoom.toFixed(2)}</span>
            </div>
            {showAggregationInfo && (
                <div className={`map-zoom-indicator__mode ${isUsingAggregations ? "map-zoom-indicator__mode--aggregations" : "map-zoom-indicator__mode--individual"}`}>
                    {isUsingAggregations ? "Aggregations" : "Individual Points"}
                </div>
            )}
            <div className="map-zoom-indicator__threshold">
                Threshold: {aggregationThreshold}
            </div>
        </div>
    );
};